var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LaptopImage"},[(_vm.imageUrl)?_c('Pic',{attrs:{"src":_vm.imageUrl}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }